export default class BidSettingsTypes{
  public static  PORTFOLIO = "Portfolio"
  public static  CAMPAIGN_LEVEL = "Campaign-level"
}
export const BidSettingsTypesList = [
  BidSettingsTypes.PORTFOLIO,
  BidSettingsTypes.CAMPAIGN_LEVEL,
]
